// extracted by mini-css-extract-plugin
export var grid = "TechBlock-module--grid--3SrBK";
export var show = "TechBlock-module--show--229AT";
export var showFadeInDown = "TechBlock-module--show-fade-in-down--yIyGK";
export var showFadeInUp = "TechBlock-module--show-fade-in-up--2dOYs";
export var hideFadeOut = "TechBlock-module--hide-fade-out--2iLes";